import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5beab80e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=5beab80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beab80e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5beab80e')) {
      api.createRecord('5beab80e', component.options)
    } else {
      api.reload('5beab80e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5beab80e&scoped=true&", function () {
      api.rerender('5beab80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_MainContacts/index.vue"
export default component.exports